import { AvailableOptions, FilterValueTypes, StringFilterOption } from '@access-erp/ui-components';

export const filtersforStringifiedNumbers: AvailableOptions<FilterValueTypes.StringFilter> = [
  StringFilterOption.Eq,
  StringFilterOption.Ne,
  StringFilterOption.Between,
  StringFilterOption.NotBetween,
  StringFilterOption.Lt,
  StringFilterOption.Le,
  StringFilterOption.Gt,
  StringFilterOption.Ge,
  StringFilterOption.IsBlank,
  StringFilterOption.IsNotBlank,
];

export const filtersforBillingTypes: AvailableOptions<FilterValueTypes.StringMultiSelectFilter> = [
  StringFilterOption.ContainsValues,
  StringFilterOption.Eq,
  StringFilterOption.Ne,
];
